import { reservationsPlugin } from './reservations/plugin';

export const pluginRegistry = [reservationsPlugin];
